import { LayerItem } from 'src/types/layer'
import EditableCell, { ParseResult } from './EditableCell'

interface EditableNameCellProps {
  initialValue: string
  rowData: LayerItem
  onUpdate: (id: string, newName: string) => Promise<void>
}

const parseString = (raw: string): ParseResult<string> => {
  const trimmed = raw.trim()
  if (trimmed.length === 0) return { valid: false, error: 'Name cannot be empty' }
  return { value: trimmed, valid: true }
}

const EditableNameCell = ({ initialValue, rowData, onUpdate }: EditableNameCellProps) => (
  <EditableCell
    value={initialValue}
    minWidth="min-w-[150px] max-w-[300px]"
    inputClassName="w-full"
    displayValue={(name) => (
      <span className="block truncate" title={name}>
        {name}
      </span>
    )}
    parseValue={parseString}
    onSave={(name) => onUpdate(rowData.id, name)}
  />
)

export default EditableNameCell
